import { SimplePagination, UserBasic } from '../_generated/openapi';
import { BasketballGameComment } from './basketball-game-comment';
import { BasketballPracticeComment } from './basketball-practice';

export enum BasketballEventType {
  GAME = 0,
  PRACTICE = 1,
  JUDGE = 2,
  REFEREE = 3,
  VISOR = 4,
  JERSEYS = 5,
  TASK = 6,
  CUSTOM = 7,
  EVENT = 8,
}

export enum BasketballEventUserRoleType {
  PLAYER = 0,
  COACH = 1,
  REFEREE = 2,
  SUPERVISOR = 3,
  JUDGE = 4,
  JERSEYS = 5,
  TASK = 6,
  CUSTOM = 7,
  PARTICIPANT = 8,
}

export const BasketballEventTypeKey: any = {
  0: 'games.singular',
  1: 'practice',
  2: 'judge',
  3: 'referee',
  4: 'visor',
  5: 'jerseys',
  8: 'events.events.singular',
};

export enum BasketballEventStatus {
  SCHEDULED = 0,
  POSTPONED = 1,
  CANCELED = 2,
  FINISHED = 3,
}

export enum BasketballEventReplyAnswer {
  UNKNOWN = 2,
  COMMITMENT = 1,
  CANCELED = 0,
}

export enum BasketballEventFilterType {
  TYPES = 'types',
  ROLES = 'roles',
  USERS = 'users',
  TEAMS = 'teams',
  TASKS = 'tasks',
}

export interface BasketballEventUserRole {
  team?: string;
  team_id?: number;
  type: BasketballEventUserRoleType;
  name?: string;
  task_id?: number;
}

export interface BasketballEventUserRolePlayerCoach
  extends BasketballEventUserRole {
  helpOut?: number;
  asCoach?: boolean;
  asPlayer?: boolean;
  reply?: {
    reply?: BasketballEventReplyAnswer;
    require_reply_reason?: boolean;
  };
  nominated: boolean;
}
export interface BasketballEventUserData {
  user: UserBasic;
  is_player_or_coach?: boolean;
  roles: BasketballEventUserRole[];
}
export interface BasketballEvent {
  id: number;
  date: string;
  end: string;
  status: BasketballEventStatus;
  description: string;
  location: string;
  gym_id?: number;
  home?: boolean;
  teams: BasketballEventTeamInfo[];
  type: BasketballEventType;
  contains_children_data?: boolean;
  editable?: boolean;
  user_data: BasketballEventUserData[];
  primary_role?: BasketballEventUserRole & {
    user_id: number;
  };
}

export interface BasketballEventCommentPagination extends SimplePagination {
  data: BasketballGameComment[] | BasketballPracticeComment[];
}

export interface BasketballEventGame extends BasketballEvent {
  home_team_id?: number;
  home_team?: string;
  guest_team_id?: number;
  guest_team?: string;
  own_referees?: boolean;
  league_id?: number;
}

export interface BasketballEventPractice extends BasketballEvent {
  limit?: number;
  editable?: boolean;
  duration?: number;
  generated?: boolean;
}

export interface BasketballEventTeamInfo {
  id: number;
  name: string;
  meet_at?: {
    meet_at_time?: string;
    meet_at_location?: string;
  };
  replies?: {
    yes: number;
    no: number;
    unknown: number;
    not_nominated: number;
  };
}

/*
export interface BasketballTeamEvent {
  allDay: boolean;
  description: string;
  end: string;
  id: string;
  location: string;
  start: string;
  status: BasketballEventStatus;
  title: string;
  type: BasketballEventType;
  editable: boolean;
}

export interface BasketballTeamEventGame extends BasketballTeamEvent {
  is_home: boolean;
  home?: string;
  guest?: string;
  home_team_id?: number;
  guest_team_id?: number;
  own_referees: boolean;
}

export interface BasketballTeamEventPractice extends BasketballTeamEvent {
  gym_id?: number;
  teams: {
    id: number;
    name: string;
  }[];
  limit: number;
}
*/
